import React, { forwardRef, useImperativeHandle, useState } from "react";


import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
export interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  showLoading?: boolean;
  variant?: "text" | "outlined" | "contained";
}

const LoadingButton = (
  { onClick, variant, label, showLoading }: IProps,
  ref: any
) => {
  const [loading, setLoading] = useState(showLoading || false);
  useImperativeHandle(
    ref,
    () => ({
      showLoading(isLoading: boolean) {
        setLoading(isLoading);
      },
    }),
    []
  );

  return (
    <Button variant={variant} onClick={onClick} disabled={loading}>
      {loading && <CircularProgress size={14} />}
      {!loading && label}
    </Button>
  );
};

export default forwardRef(LoadingButton);
